import type { FC } from "react";
import type { UserRole } from "../auth/auth";
import { featureFlags } from "../featureFlags/featureFlags";
import CustomerOrderPage from "../orders2/CustomerOrderPage";
import OldCustomerOrderPage from "./CustomerOrderPage";
import EditOrderPage from "./EditOrderPage";

const OrderPage: FC<{ role: UserRole }> = ({ role }) => {
  if (role === "ADMIN" || role === "AGENT") {
    return <EditOrderPage role={role} />;
  }
  if (featureFlags.enabled("packages2.0")) {
    return <CustomerOrderPage />;
  }
  return <OldCustomerOrderPage />;
};

export default OrderPage;
